import { LicenseLiabilityResolverService } from './license-liability-resolver.service';
import { HomeComponent } from './home/home.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddLicenseComponent } from './add-license/add-license.component';
import { AddLiabilityComponent } from './add-liability/add-liability.component';
import { LicensesComponent } from './licenses/licenses.component';
import { LiabilitiesComponent } from './liabilities/liabilities.component';


const routes: Routes = [
  { path: '', component: HomeComponent, data: { list: true, activeClass: "manage-practice" } },
  { path: 'licenses', component: LicensesComponent, data: { activeClass: "manage-practice" } },
  { path: 'liabilities', component: LiabilitiesComponent, data: { activeClass: "manage-practice" } },
  { path: 'licenses/add', component: AddLicenseComponent, data: { activeClass: "manage-practice" } },
  { path: 'licenses/edit/:id', component: AddLicenseComponent, data: { activeClass: "manage-practice" } },
  { path: 'liabilities/add', component: AddLiabilityComponent, data: { activeClass: "manage-practice" } },
  { path: 'liabilities/edit/:id', component: AddLiabilityComponent, data: { activeClass: "manage-practice" } },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LicenseLiabilityRoutingModule { }
